<template>
  <button
    type="button"
    @click="$emit('click')"
    class="flex flex-row-reverse bg-indigo-600 text-white hover:bg-indigo-500 active:bg-indigo-500 font-bold text-xs rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
    style="transition: all 0.15s ease 0s;"
  >
    {{ text }}

    <svg-icon :icon="icon" class="color-white" style="display:inline"/>
  </button>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
export default {
  components: { SvgIcon },
  props: ["text", "icon"],
};
</script>

<style></style>
